import dictionaryApiFactory from '../../modules/dictionary/dictionaryApi';

/* Actions */
import {getDictionaryActionCreators, getDictionaryDetailActionCreators} from '../actions/dictionaryActions';

/* Utils */
import {
  generateDefaultAsyncSaga,
  generateDefaultAsyncWatcher,
} from '../core/reduxUtils';

function dictionarySagasFactory({storefrontApiClient}) {
  const dictionaryApi = dictionaryApiFactory(storefrontApiClient);

  const getDictionarySagas = generateDefaultAsyncSaga(
    dictionaryApi.getDictionary,
    getDictionaryActionCreators,
    payload => [
      payload.categoryId,
      payload.params,
    ]
  );

  const getDictionaryDetailSagas = generateDefaultAsyncSaga(
    dictionaryApi.getDictionaryDetail,
    getDictionaryDetailActionCreators,
    payload => [
      payload.categoryId,
      payload.keyword,
    ]
  );

  const watchGetDictionary = generateDefaultAsyncWatcher(
    'GET_DICTIONARY_INFO',
    getDictionarySagas
  );

  const watchGetDictionaryDetail = generateDefaultAsyncWatcher(
    'GET_DICTIONARY_DETAIL',
    getDictionaryDetailSagas
  );

  const dictionarySagas = [
    watchGetDictionary(),
    watchGetDictionaryDetail(),
  ];

  return dictionarySagas;
}

export default dictionarySagasFactory;







